<template>
  <lb-drawer
    :value="value"
    heading="View Accounts"
    hide-menu
    data-testid="task-summary-accounts__drawer"
    @input="$emit('input', $event)"
  >
    <template v-slot:body>
      <div class="view-accounts-drawer" data-testid="view-accounts-drawer">
        <lb-datatableaction
          :headers="headers"
          :tabledata="accountRows"
          :displayed-row-count="accountRows.length"
          :itemsperpage="accountRows.length || 25"
          :bulk-actions="false"
          :show-toolbar="false"
          :auto-height="true"
          :enable-column-reorder="false"
          header-bg-class="tableHeaderBg"
          data-testid="view-accounts-drawer__table"
        >
          <template #tbody>
            <tr
              v-for="(item, index) in accountRows"
              :key="item._id || item.glcode || index"
              class="view-accounts-drawer__row"
              :data-testid="`view-accounts-drawer__row-${index}`"
            >
              <td
                v-for="header in visibleHeaders"
                :key="`${header.value}-${index}`"
                class="px-4"
                :class="[
                  isNumericColumn(header.value) ? 'view-accounts-drawer__td--right' : '',
                  header.value === 'name' ? 'view-accounts-drawer__td--name' : 'single-line',
                ]"
                :data-testid="`view-accounts-drawer__cell-${header.value}-${index}`"
              >
                {{ item[header.value] }}
              </td>
            </tr>

            <tr v-if="!accountRows.length">
              <td
                :colspan="visibleHeaders.length"
                class="px-4 py-6 text-center view-accounts-drawer__empty"
                data-testid="view-accounts-drawer__empty"
              >
                No linked accounts
              </td>
            </tr>
          </template>
        </lb-datatableaction>
      </div>
    </template>
  </lb-drawer>
</template>

<script>
import './TaskSummaryAccountsDrawer.scss';
import {
  getLinkedAccountsViewTableHeaders,
  LINKED_ACCOUNTS_NUMERIC_COLUMNS,
} from '@/modules/financialclose/utils/constants';

const NUMERIC_COLUMNS = new Set(LINKED_ACCOUNTS_NUMERIC_COLUMNS);

export default {
  name: 'TaskSummaryAccountsDrawer',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    accounts: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    headers() {
      return getLinkedAccountsViewTableHeaders();
    },

    visibleHeaders() {
      return this.headers.filter((header) => header.visible !== false);
    },

    accountRows() {
      return (this.accounts || []).map((account) => ({
        _id: account._id || account.glcode,
        glcode: account.glcode || '—',
        type: account.type || '—',
        name: account.name || '—',
        category: account.category || '—',
        subcategory: account.subcategory ?? account.sub_category ?? '—',
        opening_amount: this.formatAmount(account.opening_amount),
        transaction: this.formatAmount(account.transaction),
        audit_entries: this.formatJournalEntries(account),
        closing_amount: this.formatAmount(account.closing_amount),
      }));
    },
  },

  methods: {
    isNumericColumn(value) {
      return NUMERIC_COLUMNS.has(value);
    },

    formatAmount(val) {
      const n = Number(val);
      if (Number.isNaN(n)) return '—';
      return n.toLocaleString('en-US', { maximumFractionDigits: 2 });
    },

    formatJournalEntries(account) {
      const value = account.audit_entries ?? account.journal_entries;
      return value !== undefined && value !== null && value !== '' ? value : '—';
    },
  },
};
</script>
